<template>
  <div class="profile">
      <span class="profile_image" >TŘ <img src="../../../assets/images/profile.jpg" alt="Tomáš Říha" /></span>
      <router-link :to="{ name: 'user', params: { id: $auth.user()._id } }" title="Zobrazit profil">{{ name }} <span>{{ role }}</span></router-link>

  </div>
</template>

<script>
import LogoutButton from 'components/LogoutButton'

export default {
  name: 'sidebar-user',
  components: {
    LogoutButton
  },
  props: {
    name: {
      type: String
    },
    role: {
      type: String
    }
  }
}
</script>
